import axios from "axios";

export const apiBase = process.env.REACT_APP_API_URL || '';


export const getCSRFToken = () => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("csrftoken="))
    ?.split("=")[1];
};

export const getList = async (url) => {
  const response = await axios.get(`${apiBase}${url}`);
  return response.data;
};

export const getObject = async (url) => {
  const response = await axios.get(`${apiBase}${url}`);
  return response;
};

export const createObject = async (url, data) => {
  const response = await axios.post(
    `${apiBase}${url}`, 
    data, 
    {
      headers: { "X-CSRFToken": getCSRFToken() },
      withCredentials: true,
    }
  );
  return response;
};

export const updateObject = async (url, data) => {
  const response = await axios.put(`${apiBase}${url}`, data);
  return response;
};

export const deleteObject = async (url, id) => {
  const response = await axios.delete(`${apiBase}${url}`, {
    headers: { "X-CSRFToken": getCSRFToken() },
    withCredentials: true, // Asegura que se envíen cookies
  });
  return response;
};
